package team.platforma.multiplatform_material_extension.ui

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.mel_ic_clear
import org.jetbrains.compose.resources.painterResource
import team.platforma.multiplatform_material_extension.model.RequiredField
import team.platforma.multiplatform_material_extension.util.FormValidator
import team.platforma.multiplatform_material_extension.util.isEnabled
import team.platforma.multiplatform_material_extension.util.rememberPhoneValidator
import team.platforma.multiplatform_material_extension.util.rememberStringValidator
import team.platforma.multiplatform_material_extension.util.visual_transformation.MaskVisualTransformation

@Deprecated("Устаревшая реализация")
@Composable
fun OutlinePhoneInputField(
    containerModifier: Modifier = Modifier,
    inputFieldModifier: Modifier = Modifier,
    value: String,
    onPhoneChanged: (String) -> Unit,
    mask: String = "## (###) ###-##-##",
    maskChar: Char = '#',
    label: String,
    validate: (Boolean) -> Unit = {},
    keyboardOptions: KeyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Phone),
    formValidator: FormValidator? = null,
    formKey: String? = null,
    requiredField: RequiredField,
    helpMessage: String,
    errorMessage: String,
    enabled: Boolean = true,
    clearDelay: Long = 20
) {
    var phoneNumber by remember { mutableStateOf(TextFieldValue(value)) }
    var validatePhoneResult by remember { mutableStateOf(false) }
    var userInput by remember { mutableStateOf(false) }
    var errorInput by remember { mutableStateOf(false) }

    val phoneValidator = rememberPhoneValidator()
    val fieldValidator = rememberStringValidator()

    val coroutineScope = rememberCoroutineScope()

    LaunchedEffect(Unit) {
        validatePhoneResult = phoneValidator.createValidatePhoneResult(
            requiredField.boolean,
            phoneNumber.text
        )

        val maskLength = mask.count { it == maskChar }
        val resultValidation = fieldValidator.createResultValidation(requiredField.boolean, validatePhoneResult, phoneNumber.text, maskLength)
        validate(resultValidation)

        formKey?.let { key ->
            formValidator?.let {
                it.setValidateState(key, resultValidation)
                it.initFormString(key, phoneNumber.text)
                it.changeFormString(key, phoneNumber.text)
            }
        }

        onPhoneChanged(phoneNumber.text)
    }


    Column(
        modifier = containerModifier
    ) {
        OutlinedTextField(
            modifier = inputFieldModifier,
            value = phoneNumber,
            onValueChange = { change ->
                var changeText = change.text.take(mask.count { it == maskChar })

                userInput = true

                val cursorPosition = change.selection.end // Сохраняем текущую позицию курсора

                if (phoneNumber.text.isEmpty()) {
                    when {
                        changeText.startsWith("+", 0) -> {
                            phoneNumber = TextFieldValue(
                                text = changeText,
                                selection = TextRange(minOf(cursorPosition, changeText.length))
                            )

                        }

                        changeText.startsWith("7", 0) -> {
                            changeText = "+$changeText"
                            phoneNumber = TextFieldValue(
                                text = changeText,
                                selection = TextRange(minOf(cursorPosition + 1, changeText.length))
                            )
                        }

                        changeText.startsWith("8", 0) -> {
                            changeText = changeText.replaceFirst("8", "+7")
                            phoneNumber = TextFieldValue(
                                text = changeText,
                                selection = TextRange(minOf(cursorPosition + 1, changeText.length))
                            )
                        }

                        changeText.startsWith("9", 0) -> {
                            changeText = "+7$changeText"
                            phoneNumber = TextFieldValue(
                                text = changeText,
                                selection = TextRange(minOf(cursorPosition + 2, changeText.length))
                            )
                        }

                        Regex("^[0-6]").containsMatchIn(changeText) -> {
                            phoneNumber = TextFieldValue(
                                text = changeText,
                                selection = TextRange(minOf(cursorPosition, changeText.length))
                            )
                        }

                    }
                } else {
                    if (changeText.matches(Regex("^[\\d+]+$"))) {
                        phoneNumber = TextFieldValue(
                            text = if (phoneNumber.text.length != changeText.length) changeText else phoneNumber.text,
                            selection = TextRange(minOf(cursorPosition, changeText.length))
                        )
                    } else if (changeText.isEmpty()) {
                        phoneNumber = TextFieldValue(
                            text = "",
                            selection = TextRange(minOf(0, changeText.length))
                        )
                    }
                }

                validatePhoneResult = phoneValidator.createValidatePhoneResult(
                    requiredField.boolean,
                    phoneNumber.text
                )

                val maskLength = mask.count { it == maskChar }

                val resultValidation = fieldValidator.createResultValidation(requiredField.boolean, validatePhoneResult, phoneNumber.text, maskLength)

                validate(resultValidation)

                formKey?.let { key ->
                    formValidator?.let {
                        it.setValidateState(key, resultValidation)
                        it.changeFormString(key, phoneNumber.text)
                    }
                }

                onPhoneChanged(phoneNumber.text)
            },
            label = { Text(label) },
            trailingIcon = {
                if (phoneNumber.text.isNotEmpty()) {
                    Icon(
                        painter = painterResource(Res.drawable.mel_ic_clear),
                        contentDescription = null,
                        modifier = Modifier.size(40.dp)
                            .clip(CircleShape)
                            .clickable(
                                enabled = formValidator?.isEnabled() ?: enabled
                            ) {
                                userInput = true
                                coroutineScope.launch {
                                    while (phoneNumber.text.isNotEmpty()) {
                                        phoneNumber = TextFieldValue(
                                            text = phoneNumber.text.dropLast(1),
                                            selection = TextRange(phoneNumber.text.length - 1)
                                        )
                                        delay(clearDelay)
                                        validatePhoneResult =
                                            phoneValidator.createValidatePhoneResult(
                                                requiredField.boolean,
                                                phoneNumber.text
                                            )

                                        val maskLength = mask.count { it == maskChar }

                                        val resultValidation = fieldValidator.createResultValidation(requiredField.boolean, validatePhoneResult, phoneNumber.text, maskLength)
                                        validate(resultValidation)
                                        formKey?.let { key ->
                                            formValidator?.let {
                                                it.setValidateState(key, resultValidation)
                                                it.changeFormString(key, phoneNumber.text)
                                            }
                                        }
                                        onPhoneChanged(phoneNumber.text)
                                    }

                                }
                            }
                    )
                }
            },
            visualTransformation = MaskVisualTransformation(mask, maskChar),
            keyboardOptions = keyboardOptions,
            isError = errorInput,
            enabled = formValidator?.isEnabled() ?: enabled
        )

        AnimatedVisibility(
            fieldValidator.showMessage(
                userInput,
                validatePhoneResult,
                requiredField.boolean,
                phoneNumber.text,
                mask.count { it == maskChar }
            )
        ) {

            errorInput = fieldValidator.isErrorInput(
                userInput,
                validatePhoneResult,
                requiredField.boolean,
                phoneNumber.text,
            )

            AnimatedContent(
                targetState = errorInput,
                transitionSpec = {
                    (fadeIn() + slideInVertically()).togetherWith(fadeOut() + slideOutVertically())
                }
            ) { isError ->
                Text(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp),
                    text = if (isError) {
                        if (requiredField.boolean && phoneNumber.text.isEmpty()) {
                            requiredField.message
                        } else {
                            errorMessage
                        }

                    } else {
                        helpMessage

                    },
                    color = if (isError) MaterialTheme.colorScheme.error else MaterialTheme.colorScheme.onSurface
                )


            }
        }

    }
}